<template>
  <el-skeleton class="w-100" animated>
    <template slot="template">
      <div :class="isCardView ? 'd-grid gap-1' : 'd-flex flex-wrap w-100'">
        <div
          v-for="index in buttons"
          :key="index"
          :class="{
            'horizontal-button me-2': isHorizontal,
            'w-100': isVertical,
          }"
        >
          <el-skeleton-item variant="button" class="skeleton-button w-100 mb-1" />
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script>
export default {
  name: 'ActionButtonSkeleton',
  computed: {
    buttons() {
      return this.isVertical ? [0, 1] : [0, 1, 2]
    },
    isCardView() {
      return this.viewMode === 'cardView'
    },
    isDetailView() {
      return this.viewMode === 'detailView'
    },
    isGridView() {
      return this.viewMode === 'gridView'
    },
    isHorizontal() {
      return (this.isGridView && !this.showDetailView) || this.isDetailView
    },
    isVertical() {
      return (this.isGridView && this.showDetailView) || this.isCardView
    },
    showDetailView() {
      return this.visibilityState({ key: 'showDetailView' })
    },
    viewMode() {
      return this.$get('viewMode')
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
}
</script>

<style lang="scss" scoped>
.skeleton-button {
  height: 32px;
  border-radius: $border-radius;
}
.horizontal-button {
  width: 150px;
}
.d-grid.gap-1 {
  grid-template-columns: 1fr 1fr;
}
</style>
